<template>
    <div class="account-page">
        <header class="top-nav">
            <button type="button" class="back-btn" @click="$router.go(-1)">
                <van-icon name="arrow-left" />
            </button>
            <div class="nav-title">{{ $t('account.manage') }}</div>
        </header>

        <main class="page-content">
            <section class="history-section">
                <div class="history-title">{{ getLabel('pageAccount.accountList', '账户列表') }}</div>
                <div v-if="bankList.length" class="account-list">
                    <article v-for="item in bankList" :key="item.id" class="account-card">
                        <div class="account-left">
                            <div class="account-icon">
                                <img :src="getBankIcon(item)" alt="">
                            </div>
                            <div class="account-info">
                                <strong>{{ item.bank }}</strong>
                                <span>{{ item.account }}</span>
                            </div>
                        </div>
                        <button type="button" class="delete-btn" @click="delCard(item.id)">
                            <van-icon name="delete-o" />
                        </button>
                    </article>
                </div>
                <div v-else class="empty-wallet-card">
                    <van-icon name="notes-o" />
                    <p>{{ getLabel('pageAccount.emptyWallet', '暂未绑定提现账户') }}</p>
                </div>
            </section>

            <section class="notice-card">
                <van-icon name="info-o" />
                <div>
                    <strong>{{ getLabel('pageAccount.noticeTitle', '重要提示') }}</strong>
                    <p>{{ getLabel('pageAccount.noticeText', '请仅绑定您本人可控的钱包地址。删除后提现时将无法继续使用该账户，如需新的地址请重新新增绑定。') }}</p>
                </div>
            </section>

            <button type="button" class="submit-btn" @click="$router.push('/addcount')">
                <van-icon name="plus" />
                {{ getLabel('pageAccount.addWithdrawAccount', '新增提现账户') }}
            </button>
        </main>
    </div>
</template>

<script>
import Fetch from "../../utils/fetch";
import Vue from "vue";
import { Icon, Dialog, Toast } from "vant";

Vue.use(Icon);
Vue.use(Dialog);
Vue.use(Toast);

export default {
    name: "account",
    data() {
        return {
            allNum: 0,
            data: {},
            appOriginalStyles: null,
            bodyOriginalBackground: "",
        };
    },
    computed: {
        bankList() {
            return Array.isArray(this.data.bank) ? this.data.bank : [];
        },
    },
    created() {
        this.$parent.footer("user", false);
    },
    mounted() {
        this.applyFullScreenLayout();
        this.start();
    },
    beforeDestroy() {
        this.restoreFullScreenLayout();
    },
    methods: {
        getLabel(key, defaultText) {
            return this.$te(key) ? this.$t(key) : defaultText;
        },
        applyFullScreenLayout() {
            const app = document.getElementById("app");
            if (!app) {
                return;
            }
            this.appOriginalStyles = {
                maxWidth: app.style.maxWidth,
                width: app.style.width,
                margin: app.style.margin,
                backgroundColor: app.style.backgroundColor,
                paddingBottom: app.style.paddingBottom,
            };
            this.bodyOriginalBackground = document.body.style.background;
            app.style.maxWidth = "100%";
            app.style.width = "100%";
            app.style.margin = "0";
            app.style.backgroundColor = "#000000";
            app.style.paddingBottom = "0";
            document.body.style.background = "#000000";
        },
        restoreFullScreenLayout() {
            const app = document.getElementById("app");
            if (app && this.appOriginalStyles) {
                app.style.maxWidth = this.appOriginalStyles.maxWidth || "";
                app.style.width = this.appOriginalStyles.width || "";
                app.style.margin = this.appOriginalStyles.margin || "";
                app.style.backgroundColor = this.appOriginalStyles.backgroundColor || "";
                app.style.paddingBottom = this.appOriginalStyles.paddingBottom || "";
            }
            document.body.style.background = this.bodyOriginalBackground || "";
        },
        start() {
            Fetch("/user/my_bank").then((r) => {
                this.data = r.data || {};
                this.allNum = Number(r.data.count || 0);
            });
        },
        delCard(id) {
            Dialog.confirm({
                title: this.getLabel("pageAccount.dialogTitle", "提示"),
                message: this.getLabel("pageAccount.confirmDelete", "确认删除该提现账户吗？"),
                confirmButtonColor: "#2d5bff",
                className: "account-dialog",
            }).then(() => {
                Fetch("/user/bank_remove", { id }).then(() => {
                    Toast(this.getLabel("pageAccount.deleteSuccess", "删除成功"));
                    this.start();
                });
            }).catch(() => {});
        },
        getBankIcon(item) {
            try {
                return require("../images/user/recharge" + item.type + ".png");
            } catch (error) {
                return require("../images/user/recharge1.png");
            }
        },
    },
};
</script>

<style lang="less" scoped>
.account-page {
    min-height: 100vh;
    background: #000;
    color: #fff;
}

.top-nav {
    position: sticky;
    top: 0;
    z-index: 50;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 56px;
    padding: 0 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    background: rgba(0, 0, 0, 0.9);
    backdrop-filter: blur(12px);
}

.back-btn {
    position: absolute;
    left: 16px;
    top: 50%;
    width: 28px;
    height: 28px;
    margin-top: -14px;
    border: 0;
    background: transparent;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}

.back-btn .van-icon {
    font-size: 22px;
}

.nav-title {
    font-size: 18px;
    font-weight: 700;
}

.page-content {
    width: 100%;
    max-width: 430px;
    margin: 0 auto;
    padding: 24px 14px 30px;
    box-sizing: border-box;
}

.account-card,
.empty-wallet-card,
.notice-card {
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.03);
    backdrop-filter: blur(12px);
}

.history-section {
    margin-bottom: 24px;
}

.history-title {
    margin: 0 0 14px 2px;
    font-size: 18px;
    font-weight: 700;
}

.account-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.account-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 16px 14px;
}

.account-left {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
    flex: 1;
}

.account-icon {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.05);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.account-icon img {
    width: 28px;
    height: 28px;
    object-fit: contain;
}

.account-info {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.account-info strong {
    color: #fff;
    font-size: 15px;
    font-weight: 700;
}

.account-info span {
    color: rgba(255, 255, 255, 0.48);
    font-size: 12px;
    line-height: 1.5;
    word-break: break-all;
}

.delete-btn {
    width: 36px;
    height: 36px;
    border: 0;
    border-radius: 10px;
    background: rgba(239, 68, 68, 0.12);
    color: #ff5d73;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.delete-btn .van-icon {
    font-size: 18px;
}

.empty-wallet-card {
    padding: 42px 18px;
    text-align: center;
}

.empty-wallet-card .van-icon {
    color: rgba(255, 255, 255, 0.15);
    font-size: 52px;
}

.empty-wallet-card p {
    margin: 16px 0 0;
    color: rgba(255, 255, 255, 0.35);
    font-size: 16px;
}

.notice-card {
    padding: 16px 14px;
    border-left: 4px solid #2d5bff;
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 26px;
}

.notice-card .van-icon {
    margin-top: 2px;
    color: #2d5bff;
    font-size: 20px;
    flex-shrink: 0;
}

.notice-card strong {
    display: block;
    margin-bottom: 6px;
    font-size: 13px;
}

.notice-card p {
    margin: 0;
    color: rgba(255, 255, 255, 0.62);
    font-size: 12px;
    line-height: 1.7;
}

.submit-btn {
    width: 100%;
    height: 48px;
    border: 0;
    border-radius: 12px;
    background: linear-gradient(135deg, #2d5bff 0%, #104af0 100%);
    box-shadow: 0 4px 15px rgba(45, 91, 255, 0.3);
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}
</style>
